/**
 * Общи условия за ползване на „APP 4 FARMERS".
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { LegalLayout } from './LegalLayout';
import { COMPANY, ContactBlock } from './company';

const TermsOfServicePage = () => (
  <LegalLayout title="Общи условия за ползване" active="/terms-of-service" updated="11.08.2026">
    <h2>1. Общи положения</h2>
    <p>
      Тези Общи условия уреждат отношенията между {COMPANY.name} („Доставчик", „ние", „нас")
      и потребителите („Потребител", „Вие", „Вас") на платформата {COMPANY.product} („Услугата").
    </p>
    <p>
      С регистрация или използване на Услугата Вие приемате тези Общи условия. Ако не сте
      съгласни с тях, моля не използвайте Услугата.
    </p>

    <ContactBlock />

    <h2>2. Описание на услугата</h2>
    <p>
      {COMPANY.product} е софтуерна платформа за управление на земеделска земя и доброволни
      замени (ДЗ), която включва:
    </p>
    <ul>
      <li>Регистър на ползватели на земеделска земя (по Булстат) и землища (по ЕКАТТЕ)</li>
      <li>Първоначални декларации за земя по ползвател, землище и стопанска година</li>
      <li>Доброволни замени (ДЗ) между ползватели и генериране на протоколи</li>
      <li>Изчертавания на поземлени имоти (масив, поземлен имот, площ, култура)</li>
      <li>Справки (С1–С11) и генериране на PDF документи</li>
      <li>Многопотребителски достъп с роли и права по землища</li>
    </ul>

    <h2>3. Типове акаунти</h2>

    <h3>3.1. Бизнес акаунт (B2B)</h3>
    <p>
      Юридически лица и еднолични търговци. Договорът се сключва между две търговски страни
      и не се прилага 14-дневното право на отказ по Закона за защита на потребителите (ЗЗП).
    </p>

    <h3>3.2. Потребителски акаунт (B2C)</h3>
    <p>
      Физически лица за лични, нетърговски цели. Прилага се 14-дневно право на отказ от
      договора от разстояние съгласно чл. 50–56 от ЗЗП.
    </p>

    <div className="info-box important">
      <h4>Право на отказ (само за B2C)</h4>
      <p>
        Физически лица имат право да се откажат от договора в 14-дневен срок от сключването
        му, без да посочват причина. Отказът се заявява с недвусмислено изявление до Доставчика
        (напр. на <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>).
      </p>
    </div>

    <h2>4. Регистрация и акаунт</h2>
    <ul>
      <li>Достъпът до Услугата се предоставя чрез потребителско име и парола.</li>
      <li>Предоставяте вярна и пълна информация и отговаряте за нейната достоверност.</li>
      <li>Отговаряте за поверителността на паролата си и за действията с Вашия профил.</li>
      <li>Уведомявате ни незабавно при неоторизиран достъп до профила.</li>
      <li>Минимална възраст за самостоятелно ползване: 18 години.</li>
    </ul>

    <h2>5. Условия за ползване и плащане</h2>
    <p>
      Обхватът, срокът и цената на ползване (абонамент/лиценз) се уговарят индивидуално с всеки
      клиент в отделен договор или оферта. Плащането се извършва съгласно договореното. Цените
      се обявяват без ДДС, освен ако е посочено друго.
    </p>
    <ul>
      <li>B2C: 14-дневно право на отказ след сключване на договора (виж т. 3.2).</li>
      <li>B2B: без право на отказ, освен при съществено неизпълнение от страна на Доставчика.</li>
      <li>При прекратяване вече платени периоди не подлежат на възстановяване, освен ако в договора е предвидено друго.</li>
    </ul>

    <h2>6. Интелектуална собственост</h2>

    <h3>6.1. Вашето съдържание</h3>
    <p>
      Запазвате всички права върху данните, които въвеждате в Услугата (ползватели, землища,
      декларации, замени, изчертавания). Ние не придобиваме права върху Вашето съдържание и го
      обработваме единствено за целите на предоставяне на Услугата — тоест за да извършваме
      изчисленията и справките, които поръчвате чрез нея (виж раздел 7).
    </p>

    <h3>6.2. Наша собственост</h3>
    <p>
      Платформата {COMPANY.product}, включително софтуер, дизайн, лога и документация, е защитена
      от авторски права и е собственост на {COMPANY.name}.
    </p>

    <h2>7. Роли и отговорност за личните данни</h2>

    <h3>7.1. Какво прави платформата</h3>
    <p>
      Платформата извършва <strong>изчисления и справки върху данните, които Вие въвеждате</strong> —
      правно основание, доброволни замени, изчертани площи, култури и произтичащите от тях суми и
      съответствия. Тя не събира данни по своя инициатива, не ги допълва от външни източници и не
      решава какво да бъде въведено. Всяко число и всяко име в системата е там, защото Вие или Ваш
      служител сте го въвели или качили.
    </p>

    <h3>7.2. Вие сте администратор на личните данни</h3>
    <p>
      По отношение на личните данни, които въвеждате (имена и наименования на ползватели,
      ЕИК/Булстат, данни на физически лица от декларации, замени и контрагенти),{' '}
      <strong>Вие сте администратор</strong> по смисъла на Общия регламент за защита на данните
      (GDPR). Вие определяте какви данни се въвеждат, с каква цел и на какво правно основание.
    </p>
    <p>Като администратор Вие отговаряте за:</p>
    <ul>
      <li>наличието на валидно правно основание за обработката на данните, които въвеждате;</li>
      <li>точността и актуалността на въведеното;</li>
      <li>информираността на субектите на данни за обработката;</li>
      <li>да не въвеждате повече данни, отколкото са необходими за целта;</li>
      <li>
        удовлетворяването на права на субектите на данни (достъп, коригиране, изтриване), за което
        Доставчикът Ви оказва техническо съдействие.
      </li>
    </ul>

    <h3>7.3. Ние сме обработващ</h3>
    <p>
      {COMPANY.name} действа като <strong>обработващ лични данни</strong> по член 28 от GDPR и
      обработва въведеното само по Ваши указания и единствено за да предостави Услугата. Не
      използваме Вашите данни за свои цели, не ги продаваме, не ги предоставяме на трети лица извън
      посочените под-обработващи и не извършваме профилиране.
    </p>
    <p>
      Подробните ни задължения — сигурност, конфиденциалност, под-обработващи, уведомяване при
      пробив, връщане и изтриване на данните — са уредени в{' '}
      <Link to="/dpa">Споразумението за обработка на лични данни (DPA)</Link>, което е неразделна
      част от тези Общи условия.
    </p>

    <h3>7.4. Разграничение</h3>
    <p>
      Доставчикът не носи отговорност за това какви лични данни сте въвели, с какво основание и
      доколко са верни. Отговорността на Доставчика е ограничена до задълженията, които GDPR възлага
      на обработващите лични данни, и до случаите, в които е действал извън Вашите указания.
    </p>

    <h2>8. Допустимо използване</h2>
    <p>Вие се съгласявате да НЕ:</p>
    <ul>
      <li>нарушавате закони или права на трети лица;</li>
      <li>въвеждате лични данни на трети лица без валидно правно основание;</li>
      <li>опитвате неоторизиран достъп до системата или до чужди данни;</li>
      <li>претоварвате, нарушавате или саботирате инфраструктурата;</li>
      <li>извличате, копирате или разпространявате данни от Услугата извън предназначението ѝ и без съгласието на Доставчика;</li>
      <li>препродавате или преотстъпвате достъпа без разрешение;</li>
      <li>използвате автоматизирани инструменти за извличане на данни (scraping).</li>
    </ul>

    <div className="info-box warning">
      <h4>Забранено съдържание</h4>
      <p>
        Строго е забранено въвеждането на незаконно или вредоносно съдържание — включително
        лични данни на трети лица без правно основание, зловреден софтуер, както и съдържание,
        нарушаващо авторски права. Нарушенията могат да бъдат докладвани на компетентните органи,
        а акаунтите — прекратени.
      </p>
    </div>

    <h2>9. Наличност</h2>
    <ul>
      <li>Полагаме разумни усилия за наличност и коректност на Услугата.</li>
      <li>Конкретни нива на обслужване (SLA), ако има, се уреждат в договора с клиента.</li>
      <li>Планираната поддръжка се обявява предварително, когато е възможно.</li>
      <li>Не гарантираме непрекъснат достъп до Услугата.</li>
    </ul>

    <h2>10. Прекратяване</h2>

    <h3>10.1. От Вас</h3>
    <ul>
      <li>Можете да прекратите ползването по всяко време съгласно договора.</li>
      <li>Предоставяме възможност за изтегляне на Вашите данни в разумен срок (напр. 30 дни).</li>
      <li>След изтичане на срока данните се изтриват съгласно Политиката за поверителност.</li>
    </ul>

    <h3>10.2. От нас</h3>
    <ul>
      <li>При нарушение на тези условия;</li>
      <li>при неплащане съгласно договора;</li>
      <li>при законово изискване;</li>
      <li>с предизвестие при прекратяване на Услугата.</li>
    </ul>

    <h2>11. Ограничение на отговорност</h2>
    <div className="info-box warning">
      <h4>Важно</h4>
      <p>
        Услугата се предоставя „както е" (as is). Не носим отговорност за косвени, случайни или
        последващи щети. Максималната ни отговорност е ограничена до сумата, платена от Вас за
        последните 12 месеца, освен ако в договора е предвидено друго.
      </p>
    </div>

    <h2>12. Защита на данни</h2>
    <p>
      Разпределението на ролите — Вие като администратор, ние като обработващ — е описано в
      раздел 7. Обработката на лични данни е описана в нашата{' '}
      <Link to="/privacy-policy">Политика за поверителност</Link>. За B2B клиенти предлагаме{' '}
      <Link to="/dpa">Споразумение за обработка на данни (DPA)</Link>.
    </p>

    <h2>13. Промени в условията</h2>
    <p>
      Запазваме правото да променяме тези условия. При съществени промени ще Ви уведомим предварително
      (напр. по имейл или чрез известие в приложението). Продължаването на използването на Услугата
      означава приемане на новите условия.
    </p>

    <h2>14. Приложимо право и спорове</h2>
    <ul>
      <li><strong>Приложимо право:</strong> българското право.</li>
      <li><strong>Компетентен съд:</strong> компетентният съд по седалището на Доставчика, освен ако императивна норма предвижда друго.</li>
      <li><strong>Алтернативно решаване (за B2C):</strong> платформата за онлайн решаване на спорове (ОРС) на ЕС.</li>
    </ul>

    <div className="contact-info">
      <h4>EU Online Dispute Resolution (ODR)</h4>
      <p>
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
          ec.europa.eu/consumers/odr
        </a>
      </p>
    </div>

    <h2>15. Контакт</h2>
    <ContactBlock title="За въпроси относно тези условия" />
  </LegalLayout>
);

export default TermsOfServicePage;
